import {
	Button,
	ColourStateSolid,
	FlexGap,
	StackHorizontal,
	StackVertical,
	Trans,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import { deleteTwoFactorConfig, useClientAccountOverview } from '@ukpostbox/client-data';
import React from 'react';
import { TwoFactorEntryType } from '../TwoFactorTypes';

function TwoFactorEntry(props: TwoFactorEntryType) {
	const { t } = useTranslation();
	const { data } = useClientAccountOverview();

	return (
		<StackHorizontal gap={FlexGap.Small}>
			<Button onClick={() => deleteTwoFactorConfig()} title='Disable' colour={ColourStateSolid.Success} />
			<StackVertical gap={FlexGap.ExtraSmall}>
				<h6 className='m-0'>
					{t(`settings.twoFactorAuth.authTypes.${props.twoStepAuthenticationTypeId.toString()}.title`)}
				</h6>
				<Trans
					defaults={`settings.twoFactorAuth.authTypes.${props.twoStepAuthenticationTypeId.toString()}.description`}
					values={{ emailAddress: data?.username }}
					components={{ bold: <strong /> }}
				/>
			</StackVertical>
		</StackHorizontal>
	);
}

export { TwoFactorEntry };
